/** @jsxImportSource @emotion/react */
"use client";

import { useSetUserFacingErrorHandler } from "@packages/sdk";
import { CloseIcon, type ThemeType, useToast } from "@packages/ui";
import { useEffect } from "react";

export const ToastErrorBridge = () => {
  const setHandler = useSetUserFacingErrorHandler();
  const toast = useToast();

  useEffect(() => {
    setHandler((message) =>
      toast(message, {
        icon: (
          <CloseIcon
            size={16}
            css={(theme: ThemeType) => ({
              color: theme.semanticColors.errorError,
            })}
          />
        ),
      }),
    );
    return () => setHandler(null);
  }, [setHandler, toast]);

  return null;
};
